import type { FieldErrors, InquiryPayload } from "../types";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Mirrors the server's schema so the user gets immediate feedback. The server
 * validates independently — this is convenience, not the security boundary.
 */
export const validateInquiry = (values: InquiryPayload): FieldErrors => {
  const errors: FieldErrors = {};

  if (values.name.trim().length < 2) {
    errors.name = "Please tell us your name.";
  }

  if (!EMAIL_PATTERN.test(values.email.trim())) {
    errors.email = "Please enter a valid email address.";
  }

  if (!values.projectType) {
    errors.projectType = "Choose the kind of project you have in mind.";
  }

  if (values.disciplines.length === 0) {
    errors.disciplines = "Select at least one area you need help with.";
  }

  if (!values.budget) {
    errors.budget = "Choose a budget range.";
  }

  if (!values.timeline) {
    errors.timeline = "Choose a timeline.";
  }

  const message = values.message.trim();
  if (message.length < 20) {
    errors.message = "Give us at least a couple of sentences so we can prepare.";
  } else if (message.length > 4000) {
    errors.message = "Please keep this under 4000 characters.";
  }

  return errors;
};
